import { Header as BaseHeader, IHeaderProps as IBaseHeaderProps } from '@bingads-webui-react/copilot-ui-base';
import { useI18nContext } from '@bingads-webui/copilot-i18n';
import React from 'react';

export interface IHeaderProps extends Omit<IBaseHeaderProps, 'i18n'> {}

export const Header: React.FC<IHeaderProps> = (props) => {
  const i18n = useI18nContext()!;

  return (
    <BaseHeader
      {...props}
      i18n={i18n}
    />
  );
};
